// extracted by mini-css-extract-plugin
export default {"container":"embed_container__fiJBl","isContainer":"embed_isContainer__1zSop","isSmall":"embed_isSmall__191YA"};